export enum LineMode{
  Item = "Item",
  ComboHeader = "ComboHeader",
  ComboItem = "ComboItem",
  Modifier  = "Modifier"
}
